export enum CommunicationsResponseDialPhoneError {
  invalidPhone = 'invalidPhone',
  invalidCallerId = 'invalidCallerId',
}
